/** 商業智慧管理路由 */
import Layout from '@/views/layout/businessLayout'

// 員工客戶分析
const customerAuth = {
  requiresAuth: true,
  index: 1,
  type: 'bi',
  subType: 'customer'
}

const customerRouter = {
  path: 'customer',
  meta: {
    icon: 'employeestatistics',
    title: '員工客戶分析',
    ...customerAuth
  },
  hidden: false,
  children: [
    {
    path: 'customerTotal', // 客戶總量分析
    component: () => import('@/views/businessIntelligence/customer/CustomerTotalStatistics'),
    meta: {
      title: '客戶總量分析',
      ...customerAuth
    }
  },
  //  {
  //   path: 'customerRecord', // 客戶跟進次數分析
  //   component: () => import('@/views/businessIntelligence/customer/CustomerRecordStatistics'),
  //   meta: {
  //     title: '客戶跟進次數分析',
  //     ...customerAuth
  //   }
  // },
  // {
  //   path: 'customerRecordmode', // 客戶跟進方式分析
  //   component: () => import('@/views/businessIntelligence/customer/CustomerRecordModeStatistics'),
  //   meta: {
  //     title: '客戶跟進方式分析',
  //     ...customerAuth
  //   }
  // }, {
  //   path: 'customerConversion', // 客戶轉化率分析
  //   component: () => import('@/views/businessIntelligence/customer/CustomerConversionStatistics'),
  //   meta: {
  //     title: '客戶轉化率分析',
  //     ...customerAuth
  //   }
  // }, {
  //   path: 'customerPool', // 公海客戶分析
  //   component: () => import('@/views/businessIntelligence/customer/CustomerPoolStatistics'),
  //   meta: {
  //     title: '公海客戶分析',
  //     ...customerAuth
  //   }
  // }, {
  //   path: 'customerCycle', // 成交週期分析
  //   component: () => import('@/views/businessIntelligence/customer/CustomerCycleStatistics'),
  //   meta: {
  //     title: '成交週期分析',
  //     ...customerAuth
  //   }
  // }
]
}

// 銷售漏斗分析
const businessAuth = {
  requiresAuth: true,
  index: 1,
  type: 'bi',
  subType: 'business'
}

const businessRouter = {
  path: 'business',
  meta: {
    icon: 'funnelstatistics',
    title: '銷售漏斗分析',
    ...businessAuth
  },
  hidden: false,
  children: [
  //   {
  //   path: 'funnelstatistics', // 銷售漏斗
  //   component: () => import('@/views/businessIntelligence/business/FunnelStatistics'),
  //   meta: {
  //     title: '銷售漏斗',
  //     ...businessAuth
  //   }
  // },
  {
    path: 'businessTrend', // 新增商機分析
    component: () => import('@/views/businessIntelligence/business/BusinessTrendStatistics'),
    meta: {
      title: '新增商機分析',
      ...businessAuth
    }
  },
   {
    path: 'businessWin', // 商機轉化率分析
    component: () => import('@/views/businessIntelligence/business/BusinessWinStatistics'),
    meta: {
      title: '商機轉化率分析',
      ...businessAuth
    }
  }]
}

// 員工業績分析
const achievementAuth = {
  requiresAuth: true,
  index: 1,
  type: 'bi',
  subType: 'contract'
}

const achievementRouter = {
  path: 'achievement',
  meta: {
    icon: 'BI_Employee_performance',
    title: '員工業績分析',
    ...achievementAuth
  },
  hidden: false,
  children: [{
    path: 'achievementCount', // 合同數量分析
    component: () => import('@/views/businessIntelligence/achievement/AchievementCountStatistics'),
    meta: {
      title: '合同數量分析',
      ...achievementAuth
    }
  }, {
    path: 'achievementMoney', // 合同金額分析
    component: () => import('@/views/businessIntelligence/achievement/AchievementMoneyStatistics'),
    meta: {
      title: '合同金額分析',
      ...achievementAuth
    }
  }, {
    path: 'achievementBack', // 回款金額分析
    component: () => import('@/views/businessIntelligence/achievement/AchievementBackStatistics'),
    meta: {
      title: '回款金額分析',
      ...achievementAuth
    }
  }, {
    path: 'achievementSummary', // 合同彙總表
    component: () => import('@/views/businessIntelligence/achievement/AchievementSummaryStatistics'),
    meta: {
      title: '合同彙總表',
      ...achievementAuth
    }
  }]
}

// 客戶畫像分析
const portraitAuth = {
  requiresAuth: true,
  index: 1,
  type: 'bi',
  subType: 'portrait'
}

const portrayalRouter = {
  path: 'portrayal',
  meta: {
    icon: 'customer',
    title: '客戶畫像分析',
    ...portraitAuth
  },
  hidden: false,
  children: [{
    path: 'portrayalAddress', // 城市分佈分析
    component: () => import('@/views/businessIntelligence/customerPortrayal/CustomerAddressStatistics'),
    meta: {
      title: '城市分佈分析',
      ...portraitAuth
    }
  }, {
    path: 'portrayalIndustry/:type', // 客戶行業分析
    component: () => import('@/views/businessIntelligence/customerPortrayal/CustomerPortrayalStatistics'),
    meta: {
      title: '客戶畫像分析',
      ...portraitAuth
    }
  }]
}

const portrayalRouterMenu = {
  path: 'portrayal',
  meta: {
    icon: 'customer',
    title: '客戶畫像分析',
    ...portraitAuth
  },
  hidden: false,
  children: [
  //   {
  //   path: 'portrayalAddress', // 城市分佈分析
  //   component: () => import('@/views/businessIntelligence/customerPortrayal/CustomerAddressStatistics'),
  //   meta: {
  //     title: '城市分佈分析',
  //     ...portraitAuth
  //   }
  // }, {
  //   path: 'portrayalIndustry/industry', // 客戶行業分析
  //   component: () => import('@/views/businessIntelligence/customerPortrayal/CustomerPortrayalStatistics'),
  //   meta: {
  //     title: '客戶行業分析',
  //     ...portraitAuth
  //   }
  // },
  // {
  //   path: 'portrayalIndustry/level', // 客戶級別分析
  //   component: () => import('@/views/businessIntelligence/customerPortrayal/CustomerPortrayalStatistics'),
  //   meta: {
  //     title: '客戶級別分析',
  //     ...portraitAuth
  //   }
  // },
   {
    path: 'portrayalIndustry/source', // 客戶來源分析
    component: () => import('@/views/businessIntelligence/customerPortrayal/CustomerPortrayalStatistics'),
    meta: {
      title: '客戶來源分析',
      ...portraitAuth
    }
  }
]
}

// 產品分析
const productAuth = {
  requiresAuth: true,
  index: 1,
  type: 'bi',
  subType: 'product'
}

const productRouter = {
  path: 'product',
  meta: {
    icon: 'productstatistics',
    title: '產品分析',
    ...productAuth
  },
  hidden: false,
  children: [{
    path: 'productstatistics', // 產品銷售情況統計
    component: () => import('@/views/businessIntelligence/product/ProductStatistics'),
    meta: {
      title: '產品銷售情況統計',
      icon: 'productstatistics',
      ...productAuth
    }
  }, {
    path: 'productCategory', // 產品分類銷量分析
    component: () => import('@/views/businessIntelligence/product/ProductCategoryStatistics'),
    meta: {
      title: '產品分類銷量分析',
      icon: 'productstatistics',
      ...productAuth
    }
  }]
}

// 排行榜
const rankingAuth = {
  requiresAuth: true,
  index: 1,
  type: 'bi',
  subType: 'ranking'
}

const rankingRouter = {
  path: 'ranking',
  meta: {
    icon: 'BI_Leaderboard',
    title: '排行榜',
    ...rankingAuth
  },
  hidden: false,
  children: [{
    path: 'rankingContract', // 合同金額排行
    component: () => import('@/views/businessIntelligence/ranking/RankingContractStatistics'),
    meta: {
      title: '合同金額排行',
      icon: 'productstatistics',
      ...rankingAuth
    }
  },
  {
    path: 'rankingReceivables', // 回款金額排行
    component: () => import('@/views/businessIntelligence/ranking/RankingReceivablesStatistics'),
    meta: {
      title: '回款金額排行',
      icon: 'productstatistics',
      ...rankingAuth
    }
  },
  // {
  //   path: 'rankingSigning', // 簽約合同排行
  //   component: () => import('@/views/businessIntelligence/ranking/RankingSigningStatistics'),
  //   meta: {
  //     title: '簽約合同排行',
  //     icon: 'productstatistics',
  //     ...rankingAuth
  //   }
  // }, {
  //   path: 'rankingProduct', // 產品銷量排行
  //   component: () => import('@/views/businessIntelligence/ranking/RankingProductStatistics'),
  //   meta: {
  //     title: '產品銷量排行',
  //     icon: 'productstatistics',
  //     ...rankingAuth
  //   }
  // },
   {
    path: 'rankingAddCustomer', // 新增客戶數排行
    component: () => import('@/views/businessIntelligence/ranking/RankingAddCustomerStatistics'),
    meta: {
      title: '新增客戶數排行',
      icon: 'productstatistics',
      ...rankingAuth
    }
  },
  // {
  //   path: 'rankingAddContacts', // 新增聯繫人數排行
  //   component: () => import('@/views/businessIntelligence/ranking/RankingAddContactsStatistics'),
  //   meta: {
  //     title: '新增聯繫人數排行',
  //     icon: 'productstatistics',
  //     ...rankingAuth
  //   }
  // }, {
  //   path: 'rankingRecordNun', // 跟進次數排行
  //   component: () => import('@/views/businessIntelligence/ranking/RankingRecordNunStatistics'),
  //   meta: {
  //     title: '跟進次數排行',
  //     icon: 'productstatistics',
  //     ...rankingAuth
  //   }
  // }, {
  //   path: 'rankingRecordCustomer', // 跟進客戶數排行
  //   component: () => import('@/views/businessIntelligence/ranking/RankingRecordCustomerStatistics'),
  //   meta: {
  //     title: '跟進客戶數排行',
  //     icon: 'productstatistics',
  //     ...rankingAuth
  //   }
  // }, {
  //   path: 'rankingExamine', // 出差次數排行
  //   component: () => import('@/views/businessIntelligence/ranking/RankingExamineStatistics'),
  //   meta: {
  //     title: '出差次數排行',
  //     icon: 'productstatistics',
  //     ...rankingAuth
  //   }
  // }
]
}

// oa分析
const oaAuth = {
  requiresAuth: false,
  index: 1,
  type: 'bi',
  subType: 'oa'
}

const oaRouter = {
  path: 'oa',
  meta: {
    icon: 'oa_analysis',
    title: '辦公分析',
    ...oaAuth
  },
  hidden: false,
  children: [{
    path: 'log', // 日誌分析
    component: () => import('@/views/businessIntelligence/oa/log'),
    meta: {
      title: '日誌分析',
      ...oaAuth
    }
  },
  // {
  //   path: 'examine', // 審批分析
  //   component: () => import('@/views/businessIntelligence/oa/examine'),
  //   meta: {
  //     title: '審批分析',
  //     ...oaAuth
  //   }
  // }
]
}


const taskCompleteRouteItem = {
  path: 'taskCompletestatistics', // 業績目標完成情況
  component: () => import('@/views/businessIntelligence/TaskCompleteStatistics'),
  meta: {
    requiresAuth: true,
    title: '業績目標完成情況',
    icon: 'taskCompletestatistics',
    index: 1,
    type: 'bi',
    subType: 'achievement'
  }
}

export const biRouter = {
  path: '/bi',
  component: Layout,
  redirect: '/bi/customerTotal',
  name: 'bi',
  hidden: true,
  meta: {
    requiresAuth: true,
    title: '商業智慧',
    index: 0,
    type: 'bi'
  },
  children: [
    ...customerRouter.children,
    ...businessRouter.children,
    ...achievementRouter.children,
    ...portrayalRouter.children,
    ...productRouter.children,
    ...rankingRouter.children,
    ...oaRouter.children,
    taskCompleteRouteItem
  ]
}

export const biRouterMenu = [
  customerRouter,
  businessRouter,
  achievementRouter,
  portrayalRouterMenu,
  productRouter,
  rankingRouter,
  oaRouter,
  taskCompleteRouteItem
]
